<template>
  <section class="f-20" id="beauty">
    <m-img class="bg" src="@/v2/pad_auto/assets/images/car.jpg" />
    <div class="beauty-3d-content" ref="car3dContent">
      <Title1 class="bg_slogan" ref="bgSlogan" v-ia />
      <Title2 class="bg-content-1" ref="title2" v-ia />
    </div>
  </section>
</template>
<script>
import Title1 from '@/v2/auto/assets/image/20/1_title.vue'
import Title2 from '@/v2/auto/assets/image/20/2_title.vue'
export default {
  components: {
    Title1,
    Title2,
  },
  data() {
    return {
      preload_: true,
    }
  },
}
</script>
<style lang="less" scoped>
.f-20 {
  width: 100%;
  background-color: rgb(0, 0, 0);
  position: relative;
  z-index: 80;

  .bg {
    width: 100%;
  }
  .beauty-3d-content {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 1;
    display: flex;
    justify-content: center;
    pointer-events: none;
    .bg_slogan {
      position: absolute;
      width: 32%;
      top: 15%;
      color: white;
    }
    .bg-content-1 {
      color: white;
      height: 4.8rem;
      position: absolute;
      bottom: 20%;
    }
  }
}
</style>
